<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>宁向进气</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">排气口</div>
          <div class="sensor2">进气口</div>
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">册子岛</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">金塘岛</span>
        </div>
        <div class="cable-img">
          <el-tooltip class="station-block station-block-left" content="1#空气制备站" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/xihoumenSensor/station/main1"></router-link>
          </el-tooltip>
          <div class="stati sta-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("当量相对湿度", humidityTooltipErrorDehumidifierEquivalentLeft, humidityAllowedMaxDehumidifierEquivalentLeft) }} <br />
                {{
                  assembleTooltip_dehumidifier(
                    "相对湿度",
                    humidityTooltipErrorDehumidifierLeft,
                    humidityAllowedMaxDehumidifierLeft,
                    runningDehumidifierLeft,
                    malfunctionDehumidifierLeft
                  )
                }}
              </div>
              <div :class="errorDehumidifierLeft" class="state-info bottom-pos" @dblclick="hrefToStation('/station/main1')">
                <p>1#空气制备站送风</p>
                <p>
                  <span
                    >当量: {{ humidityDehumidifierEquivalentLeft | toFixed }}% <br />
                    {{ humidityDehumidifierLeft | toFixed }}% {{ temperatureDehumidifierLeft | toFixed }}°C</span
                  >
                  <span :class="runningClassLeft" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-right" content="2#空气制备站" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/xihoumenSensor/station/main2"></router-link>
          </el-tooltip>
          <div class="stati sta-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("当量相对湿度", humidityTooltipErrorDehumidifierEquivalentRight, humidityAllowedMaxDehumidifierEquivalentRight) }} <br />
                {{
                  assembleTooltip_dehumidifier(
                    "相对湿度",
                    humidityTooltipErrorDehumidifierRight,
                    humidityAllowedMaxDehumidifierRight,
                    runningDehumidifierRight,
                    malfunctionDehumidifierRight
                  )
                }}
              </div>
              <div :class="errorDehumidifierRight" class="state-info bottom-pos" @dblclick="hrefToStation('/station/main2')">
                <p>2#空气制备站送风</p>
                <p>
                  <span
                    >当量: {{ humidityDehumidifierEquivalentRight | toFixed }}% <br />
                    {{ humidityDehumidifierRight | toFixed }}% {{ temperatureDehumidifierRight | toFixed }}°C</span
                  >
                  <span :class="runningClassRight" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>



          <div class="clip sensor2 sensor-left-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJN1, humidityAllowedMaxJN1) }}
              </div>
              <div :class="errorJN1" class="state-info right-pos" @dblclick="hrefToScenario('02b15cca-50f6-4239-867b-213b95f9754c')">
                <p>JN1传感器</p>
                <p>
                  <span
                    >{{ humidityJN1 | toFixed }}% {{ temperatureJN1 | toFixed }}°C <br />
                    {{ pressureJN1 | toFixed }}Pa {{ flowJN1 | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-left-4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJN3, humidityAllowedMaxJN3) }}
              </div>
              <div :class="errorJN3" class="state-info right-pos" @dblclick="hrefToScenario('bd1748ec-dcfa-4d4f-8f15-2d6f9c7770df')">
                <p>JN3传感器</p>
                <p>
                  <span
                    >{{ humidityJN3 | toFixed }}% {{ temperatureJN3 | toFixed }}°C <br />
                    {{ pressureJN3 | toFixed }}Pa {{ flowJN3 | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-middle-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJNM5, humidityAllowedMaxJNM5) }}
              </div>
              <div :class="errorJNM5" class="state-info left-pos" @dblclick="hrefToScenario('312887fb-e005-4fc5-b160-d27bb35ee9e3')">
                <p>JNM5传感器</p>
                <p>
                  <span
                    >{{ humidityJNM5 | toFixed }}% {{ temperatureJNM5 | toFixed }}°C <br />
                    {{ pressureJNM5 | toFixed }}Pa {{ flowJNM5 | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-middle-4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJNM3, humidityAllowedMaxJNM3) }}
              </div>
              <div :class="errorJNM3" class="state-info left-pos" @dblclick="hrefToScenario('3df4976e-0806-41df-85f7-2982cd6e4310')">
                <p>JNM3传感器</p>
                <p>
                  <span
                    >{{ humidityJNM3 | toFixed }}% {{ temperatureJNM3 | toFixed }}°C <br />
                    {{ pressureJNM3 | toFixed }}Pa {{ flowJNM3 | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-middle-6">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJNM1, humidityAllowedMaxJNM1) }}
              </div>
              <div :class="errorJNM1" class="state-info right-pos" @dblclick="hrefToScenario('1b911f82-20cf-49b7-bf76-5ea2365d13db')">
                <p>JNM1传感器</p>
                <p>
                  <span
                    >{{ humidityJNM1 | toFixed }}% {{ temperatureJNM1 | toFixed }}°C <br />
                    {{ pressureJNM1 | toFixed }}Pa {{ flowJNM1 | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-middle-8">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJNM1Plus, humidityAllowedMaxJNM1Plus) }}
              </div>
              <div :class="errorJNM1Plus" class="state-info left-pos" @dblclick="hrefToScenario('51167119-1e83-4de0-8508-143c424f9cca')">
                <p>JNM1+传感器</p>
                <p>
                  <span
                    >{{ humidityJNM1Plus | toFixed }}% {{ temperatureJNM1Plus | toFixed }}°C <br />
                    {{ pressureJNM1Plus | toFixed }}Pa {{ flowJNM1Plus | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-middle-10">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJNM3Plus, humidityAllowedMaxJNM3Plus) }}
              </div>
              <div :class="errorJNM3Plus" class="state-info right-pos" @dblclick="hrefToScenario('2522e7af-5ea6-4fbb-b260-df248bdc15ca')">
                <p>JNM3+传感器</p>
                <p>
                  <span
                    >{{ humidityJNM3Plus | toFixed }}% {{ temperatureJNM3Plus | toFixed }}°C <br />
                    {{ pressureJNM3Plus | toFixed }}Pa {{ flowJNM3Plus | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-middle-12">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJNM5Plus, humidityAllowedMaxJNM5Plus) }}
              </div>
              <div :class="errorJNM5Plus" class="state-info right-pos" @dblclick="hrefToScenario('7f84382d-35ac-4f19-a1da-e1dd76d128d6')">
                <p>JNM5+传感器</p>
                <p>
                  <span
                    >{{ humidityJNM5Plus | toFixed }}% {{ temperatureJNM5Plus | toFixed }}°C <br />
                    {{ pressureJNM5Plus | toFixed }}Pa {{ flowJNM5Plus | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-right-4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJN3Plus, humidityAllowedMaxJN3Plus) }}
              </div>
              <div :class="errorJN3Plus" class="state-info left-pos" @dblclick="hrefToScenario('92fd2bc2-30f1-4aeb-a635-a6730b108300')">
                <p>JN3+传感器</p>
                <p>
                  <span
                    >{{ humidityJN3Plus | toFixed }}% {{ temperatureJN3Plus | toFixed }}°C <br />
                    {{ pressureJN3Plus | toFixed }}Pa {{ flowJN3Plus | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-right-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJN1Plus, humidityAllowedMaxJN1Plus) }}
              </div>
              <div :class="errorJN1Plus" class="state-info left-pos" @dblclick="hrefToScenario('43929a23-b992-4c36-8b68-2dcffc014724')">
                <p>JN1+传感器</p>
                <p>
                  <span
                    >{{ humidityJN1Plus | toFixed }}% {{ temperatureJN1Plus | toFixed }}°C <br />
                    {{ pressureJN1Plus | toFixed }}Pa {{ flowJN1Plus | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>宁向排气</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">排气口</div>
          <div class="sensor2">进气口</div>
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">册子岛</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">金塘岛</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor1 sensor-left-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPN0, humidityAllowedMaxPN0) }}
              </div>
              <div :class="errorPN0" class="state-info right-pos" @dblclick="hrefToScenario('7b6f26ba-073f-437c-9d9a-6363da979077')">
                <p>PN0传感器</p>
                <p>
                  <span
                    >{{ humidityPN0 | toFixed }}% {{ temperaturePN0 | toFixed }}°C <br />
                    {{ pressurePN0 | toFixed }}Pa {{ flowPN0 | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-left-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPN2, humidityAllowedMaxPN2) }}
              </div>
              <div :class="errorPN2" class="state-info right-pos" @dblclick="hrefToScenario('b728b791-bb02-4539-a05f-df2b4ea127bd')">
                <p>PN2传感器</p>
                <p>
                  <span
                    >{{ humidityPN2 | toFixed }}% {{ temperaturePN2 | toFixed }}°C <br />
                    {{ pressurePN2 | toFixed }}Pa {{ flowPN2 | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-left-5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPN4, humidityAllowedMaxPN4) }}
              </div>
              <div :class="errorPN4" class="state-info right-pos" @dblclick="hrefToScenario('86ef74ee-b1ec-4983-8531-657c4db2806c')">
                <p>PN4传感器</p>
                <p>
                  <span
                    >{{ humidityPN4 | toFixed }}% {{ temperaturePN4 | toFixed }}°C <br />
                    {{ pressurePN4 | toFixed }}Pa {{ flowPN4 | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPNM6, humidityAllowedMaxPNM6) }}
              </div>
              <div :class="errorPNM6" class="state-info left-pos" @dblclick="hrefToScenario('e7bc22c8-d3bc-4ccb-b30e-6fe05a596d76')">
                <p>PNM6传感器</p>
                <p>
                  <span
                    >{{ humidityPNM6 | toFixed }}% {{ temperaturePNM6 | toFixed }}°C <br />
                    {{ pressurePNM6 | toFixed }}Pa {{ flowPNM6 | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPNM4, humidityAllowedMaxPNM4) }}
              </div>
              <div :class="errorPNM4" class="state-info left-pos" @dblclick="hrefToScenario('a8a07697-4115-4738-9090-c5ae7bf02105')">
                <p>PNM4传感器</p>
                <p>
                  <span
                    >{{ humidityPNM4 | toFixed }}% {{ temperaturePNM4 | toFixed }}°C <br />
                    {{ pressurePNM4 | toFixed }}Pa {{ flowPNM4 | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPNM2, humidityAllowedMaxPNM2) }}
              </div>
              <div :class="errorPNM2" class="state-info right-pos" @dblclick="hrefToScenario('1ae3f3d4-f1b1-4e1e-9ac5-69056c01955c')">
                <p>PNM2传感器</p>
                <p>
                  <span
                    >{{ humidityPNM2 | toFixed }}% {{ temperaturePNM2 | toFixed }}°C <br />
                    {{ pressurePNM2 | toFixed }}Pa {{ flowPNM2 | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-7">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPNM0, humidityAllowedMaxPNM0) }}
              </div>
              <div :class="errorPNM0" class="state-info top-pos" @dblclick="hrefToScenario('5dd65392-06a8-4fe7-b50b-4f2b8e0a4884')">
                <p>PNM0传感器</p>
                <p>
                  <span
                    >{{ humidityPNM0 | toFixed }}% {{ temperaturePNM0 | toFixed }}°C <br />
                    {{ pressurePNM0 | toFixed }}Pa {{ flowPNM0 | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-9">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPNM2Plus, humidityAllowedMaxPNM2Plus) }}
              </div>
              <div :class="errorPNM2Plus" class="state-info left-pos" @dblclick="hrefToScenario('180f36f9-768c-466e-9ab9-ff4cdfe2636f')">
                <p>PNM2+传感器</p>
                <p>
                  <span
                    >{{ humidityPNM2Plus | toFixed }}% {{ temperaturePNM2Plus | toFixed }}°C <br />
                    {{ pressurePNM2Plus | toFixed }}Pa {{ flowPNM2Plus | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-11">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPNM4Plus, humidityAllowedMaxPNM4Plus) }}
              </div>
              <div :class="errorPNM4Plus" class="state-info right-pos" @dblclick="hrefToScenario('5905a8b3-2a13-4ca1-86a9-98bd4326c2ca')">
                <p>PNM4+传感器</p>
                <p>
                  <span
                    >{{ humidityPNM4Plus | toFixed }}% {{ temperaturePNM4Plus | toFixed }}°C <br />
                    {{ pressurePNM4Plus | toFixed }}Pa {{ flowPNM4Plus | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-13">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPNM6Plus, humidityAllowedMaxPNM6Plus) }}
              </div>
              <div :class="errorPNM6Plus" class="state-info right-pos" @dblclick="hrefToScenario('facec22d-308f-495f-87e6-486391efe862')">
                <p>PNM6+传感器</p>
                <p>
                  <span
                    >{{ humidityPNM6Plus | toFixed }}% {{ temperaturePNM6Plus | toFixed }}°C <br />
                    {{ pressurePNM6Plus | toFixed }}Pa {{ flowPNM6Plus | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-right-5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPN4Plus, humidityAllowedMaxPN4Plus) }}
              </div>
              <div :class="errorPN4Plus" class="state-info left-pos" @dblclick="hrefToScenario('5d15dadc-d16a-4127-98ef-070dd43746f7')">
                <p>PN4+传感器</p>
                <p>
                  <span
                    >{{ humidityPN4Plus | toFixed }}% {{ temperaturePN4Plus | toFixed }}°C <br />
                    {{ pressurePN4Plus | toFixed }}Pa {{ flowPN4Plus | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-right-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPN2Plus, humidityAllowedMaxPN2Plus) }}
              </div>
              <div :class="errorPN2Plus" class="state-info left-pos" @dblclick="hrefToScenario('1d8430a6-1f43-4dc3-8edb-35763da86a79')">
                <p>PN2+传感器</p>
                <p>
                  <span
                    >{{ humidityPN2Plus | toFixed }}% {{ temperaturePN2Plus | toFixed }}°C <br />
                    {{ pressurePN2Plus | toFixed }}Pa {{ flowPN2Plus | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-right-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorPN0Plus, humidityAllowedMaxPN0Plus) }}
              </div>
              <div :class="errorPN0Plus" class="state-info left-pos" @dblclick="hrefToScenario('71beb066-ce67-495e-bdc7-87a222734b2d')">
                <p>PN0+传感器</p>
                <p>
                  <span
                    >{{ humidityPN0Plus | toFixed }}% {{ temperaturePN0Plus | toFixed }}°C <br />
                    {{ pressurePN0Plus | toFixed }}Pa {{ flowPN0Plus | toFixed }}m³/h
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
      
      <script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      routerPrefix: "xihoumenSensor",
      bridgeId: "3aeeb5b1-f586-43c4-b03c-2e5880d2e541",

      //humidity, temperature
      humidityPZ0: "--",
      humidityPN0: "--",
      humidityJZ1: "--",
      humidityJN1: "--",
      humidityPZ2: "--",
      humidityPN2: "--",
      humidityJZ3: "--",
      humidityJN3: "--",
      humidityPZ4: "--",
      humidityPN4: "--",
      humidityPZM6: "--",
      humidityPNM6: "--",
      humidityJZM5: "--",
      humidityJNM5: "--",
      humidityPZM4: "--",
      humidityPNM4: "--",
      humidityJZM3: "--",
      humidityJNM3: "--",
      humidityPZM2: "--",
      humidityPNM2: "--",
      humidityJZM1: "--",
      humidityJNM1: "--",
      humidityPZM0: "--",
      humidityPNM0: "--",
      humidityPZ0Plus: "--",
      humidityPN0Plus: "--",
      humidityJZ1Plus: "--",
      humidityJN1Plus: "--",
      humidityPZ2Plus: "--",
      humidityPN2Plus: "--",
      humidityJZ3Plus: "--",
      humidityJN3Plus: "--",
      humidityPZ4Plus: "--",
      humidityPN4Plus: "--",
      humidityPZM6Plus: "--",
      humidityPNM6Plus: "--",
      humidityJZM5Plus: "--",
      humidityJNM5Plus: "--",
      humidityPZM4Plus: "--",
      humidityPNM4Plus: "--",
      humidityJZM3Plus: "--",
      humidityJNM3Plus: "--",
      humidityPZM2Plus: "--",
      humidityPNM2Plus: "--",
      humidityJZM1Plus: "--",
      humidityJNM1Plus: "--",
      humidityDehumidifierLeft: "--",
      humidityDehumidifierRight: "--",
      humidityDehumidifierEquivalentLeft: "--",
      humidityDehumidifierEquivalentRight: "--",
      humidityDehumidifierSteelboxSouthTower: "--",

      temperaturePZ0: "--",
      temperaturePN0: "--",
      temperatureJZ1: "--",
      temperatureJN1: "--",
      temperaturePZ2: "--",
      temperaturePN2: "--",
      temperatureJZ3: "--",
      temperatureJN3: "--",
      temperaturePZ4: "--",
      temperaturePN4: "--",
      temperaturePZM6: "--",
      temperaturePNM6: "--",
      temperatureJZM5: "--",
      temperatureJNM5: "--",
      temperaturePZM4: "--",
      temperaturePNM4: "--",
      temperatureJZM3: "--",
      temperatureJNM3: "--",
      temperaturePZM2: "--",
      temperaturePNM2: "--",
      temperatureJZM1: "--",
      temperatureJNM1: "--",
      temperaturePZM0: "--",
      temperaturePNM0: "--",
      temperaturePZ0Plus: "--",
      temperaturePN0Plus: "--",
      temperatureJZ1Plus: "--",
      temperatureJN1Plus: "--",
      temperaturePZ2Plus: "--",
      temperaturePN2Plus: "--",
      temperatureJZ3Plus: "--",
      temperatureJN3Plus: "--",
      temperaturePZ4Plus: "--",
      temperaturePN4Plus: "--",
      temperaturePZM6Plus: "--",
      temperaturePNM6Plus: "--",
      temperatureJZM5Plus: "--",
      temperatureJNM5Plus: "--",
      temperaturePZM4Plus: "--",
      temperaturePNM4Plus: "--",
      temperatureJZM3Plus: "--",
      temperatureJNM3Plus: "--",
      temperaturePZM2Plus: "--",
      temperaturePNM2Plus: "--",
      temperatureJZM1Plus: "--",
      temperatureJNM1Plus: "--",
      temperatureDehumidifierLeft: "--",
      temperatureDehumidifierRight: "--",
      temperatureDehumidifierSteelboxSouthTower: "--",

      pressurePZ0: "--",
      pressurePN0: "--",
      pressureJZ1: "--",
      pressureJN1: "--",
      pressurePZ2: "--",
      pressurePN2: "--",
      pressureJZ3: "--",
      pressureJN3: "--",
      pressurePZ4: "--",
      pressurePN4: "--",
      pressurePZM6: "--",
      pressurePNM6: "--",
      pressureJZM5: "--",
      pressureJNM5: "--",
      pressurePZM4: "--",
      pressurePNM4: "--",
      pressureJZM3: "--",
      pressureJNM3: "--",
      pressurePZM2: "--",
      pressurePNM2: "--",
      pressureJZM1: "--",
      pressureJNM1: "--",
      pressurePZM0: "--",
      pressurePNM0: "--",
      pressurePZ0Plus: "--",
      pressurePN0Plus: "--",
      pressureJZ1Plus: "--",
      pressureJN1Plus: "--",
      pressurePZ2Plus: "--",
      pressurePN2Plus: "--",
      pressureJZ3Plus: "--",
      pressureJN3Plus: "--",
      pressurePZ4Plus: "--",
      pressurePN4Plus: "--",
      pressurePZM6Plus: "--",
      pressurePNM6Plus: "--",
      pressureJZM5Plus: "--",
      pressureJNM5Plus: "--",
      pressurePZM4Plus: "--",
      pressurePNM4Plus: "--",
      pressureJZM3Plus: "--",
      pressureJNM3Plus: "--",
      pressurePZM2Plus: "--",
      pressurePNM2Plus: "--",
      pressureJZM1Plus: "--",
      pressureJNM1Plus: "--",
      pressureDehumidifierSteelboxSouthTower: "--",

      flowPZ0: "--",
      flowPN0: "--",
      flowJZ1: "--",
      flowJN1: "--",
      flowPZ2: "--",
      flowPN2: "--",
      flowJZ3: "--",
      flowJN3: "--",
      flowPZ4: "--",
      flowPN4: "--",
      flowPZM6: "--",
      flowPNM6: "--",
      flowJZM5: "--",
      flowJNM5: "--",
      flowPZM4: "--",
      flowPNM4: "--",
      flowJZM3: "--",
      flowJNM3: "--",
      flowPZM2: "--",
      flowPNM2: "--",
      flowJZM1: "--",
      flowJNM1: "--",
      flowPZM0: "--",
      flowPNM0: "--",
      flowPZ0Plus: "--",
      flowPN0Plus: "--",
      flowJZ1Plus: "--",
      flowJN1Plus: "--",
      flowPZ2Plus: "--",
      flowPN2Plus: "--",
      flowJZ3Plus: "--",
      flowJN3Plus: "--",
      flowPZ4Plus: "--",
      flowPN4Plus: "--",
      flowPZM6Plus: "--",
      flowPNM6Plus: "--",
      flowJZM5Plus: "--",
      flowJNM5Plus: "--",
      flowPZM4Plus: "--",
      flowPNM4Plus: "--",
      flowJZM3Plus: "--",
      flowJNM3Plus: "--",
      flowPZM2Plus: "--",
      flowPNM2Plus: "--",
      flowJZM1Plus: "--",
      flowJNM1Plus: "--",

      //running
      runningDehumidifierLeft: "--",
      runningDehumidifierRight: "--",
      runningDehumidifierSteelboxSouthTower: "--",


      //malfunction
      malfunctionDehumidifierLeft: "--",
      malfunctionDehumidifierRight: "--",

      //error
      errorPZ0: "--",
      errorPN0: "--",
      errorJZ1: "--",
      errorJN1: "--",
      errorPZ2: "--",
      errorPN2: "--",
      errorJZ3: "--",
      errorJN3: "--",
      errorPZ4: "--",
      errorPN4: "--",
      errorPZM6: "--",
      errorPNM6: "--",
      errorJZM5: "--",
      errorJNM5: "--",
      errorPZM4: "--",
      errorPNM4: "--",
      errorJZM3: "--",
      errorJNM3: "--",
      errorPZM2: "--",
      errorPNM2: "--",
      errorJZM1: "--",
      errorJNM1: "--",
      errorPZM0: "--",
      errorPNM0: "--",
      errorPZ0Plus: "--",
      errorPN0Plus: "--",
      errorJZ1Plus: "--",
      errorJN1Plus: "--",
      errorPZ2Plus: "--",
      errorPN2Plus: "--",
      errorJZ3Plus: "--",
      errorJN3Plus: "--",
      errorPZ4Plus: "--",
      errorPN4Plus: "--",
      errorPZM6Plus: "--",
      errorPNM6Plus: "--",
      errorJZM5Plus: "--",
      errorJNM5Plus: "--",
      errorPZM4Plus: "--",
      errorPNM4Plus: "--",
      errorJZM3Plus: "--",
      errorJNM3Plus: "--",
      errorPZM2Plus: "--",
      errorPNM2Plus: "--",
      errorJZM1Plus: "--",
      errorJNM1Plus: "--",
      errorDehumidifierLeft: "--",
      errorDehumidifierRight: "--",
      errorDehumidifierSteelboxSouthTower: "--",

      //running class
      runningClassLeft: "--",
      runningClassRight: "--",
      runningClassSteelboxSouthTower: "--",

      //humidity allowed max
      humidityAllowedMaxPZ0: "--",
      humidityAllowedMaxPN0: "--",
      humidityAllowedMaxJZ1: "--",
      humidityAllowedMaxJN1: "--",
      humidityAllowedMaxPZ2: "--",
      humidityAllowedMaxPN2: "--",
      humidityAllowedMaxJZ3: "--",
      humidityAllowedMaxJN3: "--",
      humidityAllowedMaxPZ4: "--",
      humidityAllowedMaxPN4: "--",
      humidityAllowedMaxPZM6: "--",
      humidityAllowedMaxPNM6: "--",
      humidityAllowedMaxJZM5: "--",
      humidityAllowedMaxJNM5: "--",
      humidityAllowedMaxPZM4: "--",
      humidityAllowedMaxPNM4: "--",
      humidityAllowedMaxJZM3: "--",
      humidityAllowedMaxJNM3: "--",
      humidityAllowedMaxPZM2: "--",
      humidityAllowedMaxPNM2: "--",
      humidityAllowedMaxJZM1: "--",
      humidityAllowedMaxJNM1: "--",
      humidityAllowedMaxPZM0: "--",
      humidityAllowedMaxPNM0: "--",
      humidityAllowedMaxPZ0Plus: "--",
      humidityAllowedMaxPN0Plus: "--",
      humidityAllowedMaxJZ1Plus: "--",
      humidityAllowedMaxJN1Plus: "--",
      humidityAllowedMaxPZ2Plus: "--",
      humidityAllowedMaxPN2Plus: "--",
      humidityAllowedMaxJZ3Plus: "--",
      humidityAllowedMaxJN3Plus: "--",
      humidityAllowedMaxPZ4Plus: "--",
      humidityAllowedMaxPN4Plus: "--",
      humidityAllowedMaxPZM6Plus: "--",
      humidityAllowedMaxPNM6Plus: "--",
      humidityAllowedMaxJZM5Plus: "--",
      humidityAllowedMaxJNM5Plus: "--",
      humidityAllowedMaxPZM4Plus: "--",
      humidityAllowedMaxPNM4Plus: "--",
      humidityAllowedMaxJZM3Plus: "--",
      humidityAllowedMaxJNM3Plus: "--",
      humidityAllowedMaxPZM2Plus: "--",
      humidityAllowedMaxPNM2Plus: "--",
      humidityAllowedMaxJZM1Plus: "--",
      humidityAllowedMaxJNM1Plus: "--",
      humidityAllowedMaxDehumidifierLeft: "--",
      humidityAllowedMaxDehumidifierRight: "--",
      humidityAllowedMaxDehumidifierEquivalentLeft: "--",
      humidityAllowedMaxDehumidifierEquivalentRight: "--",
      humidityAllowedMaxDehumidifierSteelboxSouthTower: "--",

      //humidity tooltip error
      humidityTooltipErrorPZ0: "--",
      humidityTooltipErrorPN0: "--",
      humidityTooltipErrorJZ1: "--",
      humidityTooltipErrorJN1: "--",
      humidityTooltipErrorPZ2: "--",
      humidityTooltipErrorPN2: "--",
      humidityTooltipErrorJZ3: "--",
      humidityTooltipErrorJN3: "--",
      humidityTooltipErrorPZ4: "--",
      humidityTooltipErrorPN4: "--",
      humidityTooltipErrorPZM6: "--",
      humidityTooltipErrorPNM6: "--",
      humidityTooltipErrorJZM5: "--",
      humidityTooltipErrorJNM5: "--",
      humidityTooltipErrorPZM4: "--",
      humidityTooltipErrorPNM4: "--",
      humidityTooltipErrorJZM3: "--",
      humidityTooltipErrorJNM3: "--",
      humidityTooltipErrorPZM2: "--",
      humidityTooltipErrorPNM2: "--",
      humidityTooltipErrorJZM1: "--",
      humidityTooltipErrorJNM1: "--",
      humidityTooltipErrorPZM0: "--",
      humidityTooltipErrorPNM0: "--",
      humidityTooltipErrorPZ0Plus: "--",
      humidityTooltipErrorPN0Plus: "--",
      humidityTooltipErrorJZ1Plus: "--",
      humidityTooltipErrorJN1Plus: "--",
      humidityTooltipErrorPZ2Plus: "--",
      humidityTooltipErrorPN2Plus: "--",
      humidityTooltipErrorJZ3Plus: "--",
      humidityTooltipErrorJN3Plus: "--",
      humidityTooltipErrorPZ4Plus: "--",
      humidityTooltipErrorPN4Plus: "--",
      humidityTooltipErrorPZM6Plus: "--",
      humidityTooltipErrorPNM6Plus: "--",
      humidityTooltipErrorJZM5Plus: "--",
      humidityTooltipErrorJNM5Plus: "--",
      humidityTooltipErrorPZM4Plus: "--",
      humidityTooltipErrorPNM4Plus: "--",
      humidityTooltipErrorJZM3Plus: "--",
      humidityTooltipErrorJNM3Plus: "--",
      humidityTooltipErrorPZM2Plus: "--",
      humidityTooltipErrorPNM2Plus: "--",
      humidityTooltipErrorJZM1Plus: "--",
      humidityTooltipErrorJNM1Plus: "--",
      humidityTooltipErrorDehumidifierLeft: "--",
      humidityTooltipErrorDehumidifierRight: "--",
      humidityTooltipErrorDehumidifierEquivalentLeft: "--",
      humidityTooltipErrorDehumidifierEquivalentRight: "--",
      humidityTooltipErrorDehumidifierSteelboxSouthTower: "--",

      dataNameIdDict: {
        //humidity, temperature
        humidityPZ0: "ca6847b7-c47e-442b-9dfe-4c4a69f6952d",
        humidityPN0: "0ea8eea2-07e1-4542-a42a-c2ebcc4da119",
        humidityJZ1: "63d6b596-de71-4aff-b322-d56359f8ae09",
        humidityJN1: "45551ad9-add9-4e48-bf43-5601cee2ef51",
        humidityPZ2: "eba2f623-e26d-49e1-85f0-b3a8043ab1fc",
        humidityPN2: "8b5e0a56-6667-4ce8-884b-3f6e44906134",
        humidityJZ3: "75510b59-4249-46a0-a35b-232edefd5319",
        humidityJN3: "63600282-7f67-4dff-b159-85c14847cb36",
        humidityPZ4: "1fe3605a-e2eb-437a-879d-4d874a727695",
        humidityPN4: "276b7a3a-3bef-4c6e-8221-d4e3a1d9883c",
        humidityPZM6: "5707b1e1-7f71-458b-88d1-b5c547e357c7",
        humidityPNM6: "dd8b03bc-14ec-4d31-8361-3551477d8de0",
        humidityJZM5: "96408d16-1ac2-4c4b-a856-f9cbe0f34626",
        humidityJNM5: "a8dd15f6-772e-450f-9c6f-b548e349c4df",
        humidityPZM4: "3c81cce8-6097-4e21-b8f2-e0bd9fff0d1b",
        humidityPNM4: "7aeb8470-606b-4e7c-9bcd-9c990aad6144",
        humidityJZM3: "ecc19039-0f6b-4297-a4c6-89c7103eefef",
        humidityJNM3: "54cd8a84-edfd-4c51-bfae-fbf7fd23918b",
        humidityPZM2: "4aa64e64-14fb-4bfb-945d-1d68c63034bc",
        humidityPNM2: "41be5c81-6ed3-49e4-96e2-076c8df56025",
        humidityJZM1: "9d271296-6d34-4080-8eb0-b7d85d401f7a",
        humidityJNM1: "f628e215-2229-454e-a25f-146fcdc41ddb",
        humidityPZM0: "ce200656-44e0-4015-9a9c-ba289f84d962",
        humidityPNM0: "60643b5d-7d4f-4b95-888c-9809cadc8c07",
        humidityPZ0Plus: "a7ac9307-f8f4-4e47-a80b-39d416f567e3",
        humidityPN0Plus: "b33586f0-cd88-4684-96c2-a820e0373a58",
        humidityJZ1Plus: "91bc95ff-6f2c-415e-ac97-af9bec16a746",
        humidityJN1Plus: "a0f66c55-3167-4117-84da-d8f2096d4441",
        humidityPZ2Plus: "70a76f2c-b4bc-43d1-99e0-23c32ff7a035",
        humidityPN2Plus: "5cfc36db-0588-4a8b-9a4f-501bb6649f34",
        humidityJZ3Plus: "4d5767ea-d8b0-4098-a8b9-b12933477bd1",
        humidityJN3Plus: "cdb3ca60-261c-4921-95f3-a0ed5a7f7ee0",
        humidityPZ4Plus: "3034b70b-f3e4-40bb-9812-b1f05e1d4634",
        humidityPN4Plus: "aca09fc4-5f70-4a6e-8705-f1790ce95a27",
        humidityPZM6Plus: "a442056b-15df-4a2c-8383-0ae148558dfc",
        humidityPNM6Plus: "833f777d-088c-4d13-9414-ea6a18a4f1a7",
        humidityJZM5Plus: "6202abe7-e0f6-4d32-ab56-eb5caa1357f4",
        humidityJNM5Plus: "8ae69e75-8d92-446c-bdb2-6ef4cf56d1b5",
        humidityPZM4Plus: "aa2338a1-49a2-41c7-973e-ad10b21a1b88",
        humidityPNM4Plus: "a47905bd-da46-4eeb-94ec-e77890ac6de2",
        humidityJZM3Plus: "7c9f6740-86b4-44e4-9b4f-932616d53b41",
        humidityJNM3Plus: "f1737f11-63ed-423e-8e9b-b8c00a9ec398",
        humidityPZM2Plus: "278ab36f-c460-446e-8f37-e09b62a967d9",
        humidityPNM2Plus: "4d74ebe0-ad25-45b5-ae39-6301830a9665",
        humidityJZM1Plus: "71c4f92c-301a-4dc9-9bcd-97cd6429eb2d",
        humidityJNM1Plus: "66d77cff-a70f-45bc-aa46-4e5d005b1a92",
        humidityDehumidifierLeft: "ea50a278-9f53-4aaf-bf2c-bb7c576a8308",
        humidityDehumidifierRight: "a7f05749-e227-4021-b390-928934fe5fea",
        humidityDehumidifierEquivalentLeft: "c0d81c98-c485-4795-8f3f-87a2b3acd516",
        humidityDehumidifierEquivalentRight: "03e55848-49d7-4551-9d05-f6dd9bd2a0cd",
        humidityDehumidifierSteelboxSouthTower: "38efbd32-db59-44f7-9070-933116d1cc49",

        temperaturePZ0: "8b08d219-66ec-45df-ac42-479cbd06836d",
        temperaturePN0: "c345ec1a-8f86-4e86-8ba7-ddabb9a0755b",
        temperatureJZ1: "6e3ee3ff-1c74-4e4f-9e57-49f915cb29cc",
        temperatureJN1: "ca258394-c475-41fa-b06f-28c28bb5b47d",
        temperaturePZ2: "605c18e0-9cf6-4bb6-a820-30f14c4b2dce",
        temperaturePN2: "c7b53a04-7881-4e09-8c6d-df475a71fdfb",
        temperatureJZ3: "452f340c-fda1-4c13-9776-722daf0a094b",
        temperatureJN3: "fcc62056-928a-4249-9c66-84d2a7bf420f",
        temperaturePZ4: "f1bb5eff-fad6-4fca-8b80-51fd08f39a52",
        temperaturePN4: "6e82a417-9960-4fa0-a45a-df0c206f1e38",
        temperaturePZM6: "b6067b16-e4a3-48c4-90ef-5007f3d0d4b8",
        temperaturePNM6: "38763ff5-0e83-4536-9c7a-57f9a5592a07",
        temperatureJZM5: "9de7430d-2d41-4ab3-8014-f0550a67d3fa",
        temperatureJNM5: "63bce6f9-e4eb-4644-a465-bb2311b0026a",
        temperaturePZM4: "b02dfb6f-3d5c-407c-8043-5855df56cb28",
        temperaturePNM4: "e40eddd9-73a9-4850-952e-52d25303f89d",
        temperatureJZM3: "d549223f-55cf-403e-a8b6-b562afc8942d",
        temperatureJNM3: "d8645d7c-ffab-43c8-83a1-8312ced6fb99",
        temperaturePZM2: "937b8781-c706-4c92-9140-6a14fc5ecd6d",
        temperaturePNM2: "258f5671-9ac2-402e-be1d-a5d39767660a",
        temperatureJZM1: "0f07aa42-f17b-4a4d-a573-bea365fa531d",
        temperatureJNM1: "e8933c1f-81d4-48a6-8842-a4fc1c344041",
        temperaturePZM0: "c8ffd59a-7f3b-4e11-b174-c5db3b3abbc6",
        temperaturePNM0: "ba4c7561-2c3f-422b-9aa6-d905b87ca306",
        temperaturePZ0Plus: "7f88abe7-3565-4cfb-a0de-75390aa839be",
        temperaturePN0Plus: "045d253b-bee3-4eb3-939e-5a6b679588eb",
        temperatureJZ1Plus: "1365bb0b-b3f0-45ad-a657-f23defed8268",
        temperatureJN1Plus: "706d5493-a16c-4f62-b5f7-bebcad04d0ec",
        temperaturePZ2Plus: "e05d4a57-d96b-4842-bb36-36a2fadefc4b",
        temperaturePN2Plus: "cf847648-65ae-4f44-8f94-c1c8fba37bc6",
        temperatureJZ3Plus: "ed109da3-c166-4af5-96ef-0d0b2ca0150f",
        temperatureJN3Plus: "ede0b763-3b72-4b10-8744-ce4794606fc3",
        temperaturePZ4Plus: "a70a93e2-92e2-4bad-97b2-40303183e452",
        temperaturePN4Plus: "60734a25-f371-4c40-bd41-ce66a736d31b",
        temperaturePZM6Plus: "33d6bdfd-a585-4b46-bb58-218970bf78b1",
        temperaturePNM6Plus: "ecd50adb-c7d0-4b55-a214-e1d4e90cfea8",
        temperatureJZM5Plus: "420a8cc9-7410-40dc-8535-7df583e9e521",
        temperatureJNM5Plus: "55afb1df-3b54-49bf-b4de-7e35c4ae870e",
        temperaturePZM4Plus: "19d529d1-79d5-4dc2-b26c-91bf037b26ef",
        temperaturePNM4Plus: "5eec857d-7170-4984-90f6-d95b1bc6bb0f",
        temperatureJZM3Plus: "267a2b93-970e-45ec-85c4-bbd293a58470",
        temperatureJNM3Plus: "9eb494bc-45ba-4234-89ea-4bdbfec7a37d",
        temperaturePZM2Plus: "951f60d5-8145-48ba-aa69-ce1152ab5552",
        temperaturePNM2Plus: "0478dcfc-3b8b-4d94-ab20-3f51820b7027",
        temperatureJZM1Plus: "ad1dc766-c63d-4e60-978e-729b9288f220",
        temperatureJNM1Plus: "1284a99b-ef60-46d6-a44d-6193e5a5f255",
        temperatureDehumidifierLeft: "cda32056-67de-4c68-ad29-6f6768497c78",
        temperatureDehumidifierRight: "c9428902-4cc1-4dc5-ba5b-bfa94381f6b3",
        temperatureDehumidifierSteelboxSouthTower: "ba5b30cb-bb8b-475f-9adf-b9b78db8d785",

        pressurePZ0: "85189cd5-2f26-463a-882a-8e89c1547e0a",
        pressurePN0: "09a015f2-41f9-4928-ab50-bf6e738807d8",
        pressureJZ1: "a5b3c3b9-a335-4ba5-a3b8-3ad916c2c219",
        pressureJN1: "11eee932-e096-4e66-a43d-624472f82277",
        pressurePZ2: "55ffe735-52b7-40b4-9dd4-d3889f227438",
        pressurePN2: "6d3fc2b1-875a-48a1-a218-7282280e756e",
        pressureJZ3: "6233925b-b5ab-42af-aad7-556105563fae",
        pressureJN3: "e36dfcb4-572c-48c8-97bf-46d1384dea16",
        pressurePZ4: "32055f1f-7f65-4359-9565-cd53fc0aa6e0",
        pressurePN4: "61956eb5-75bd-4e19-bb0e-368d742db856",
        pressurePZM6: "c87e3b6a-2b74-4ed2-a805-299414f65017",
        pressurePNM6: "8a478348-151a-4845-b23f-3745c97dbccc",
        pressureJZM5: "abef8649-1a72-4ba3-8ab9-397fcbf53423",
        pressureJNM5: "af1a3cff-1311-4977-a1b9-a46107e325bf",
        pressurePZM4: "0f75ade0-1db9-4991-84e4-d88f77d479b1",
        pressurePNM4: "0ebf16ff-15c4-4e66-b363-5763f006a80f",
        pressureJZM3: "9ac3ca0c-f0a9-4a94-8cec-d0f3c1463f34",
        pressureJNM3: "dd240475-cd32-475f-a4ca-7f738b38e805",
        pressurePZM2: "97c7d300-ed4c-4a9e-971c-f1dddfe6ab5d",
        pressurePNM2: "2b6f29ba-2074-4a4b-83b0-977553bc5b6c",
        pressureJZM1: "e6374167-1f58-4ba8-a8d2-bb645b17381f",
        pressureJNM1: "8729968d-7088-4ded-984d-e86e2ff30576",
        pressurePZM0: "44d04788-e50b-4b4a-bae2-ca35f9c4323b",
        pressurePNM0: "bc5f3f62-6e38-4169-81c3-5e9994bc0ea8",
        pressurePZ0Plus: "fb211a9a-30f6-4b4e-90e1-361b61bab53b",
        pressurePN0Plus: "e7a43c47-eb95-4a5e-ac37-6838d00f64e5",
        pressureJZ1Plus: "f99b5e17-7cf8-4780-bb51-436a0d5941ee",
        pressureJN1Plus: "2c885108-cc07-4f8d-b4af-af424a573840",
        pressurePZ2Plus: "db85df55-4625-40ea-a98e-c9c51017e6ac",
        pressurePN2Plus: "80361940-7fc6-4aa3-a67c-56a25caf61d2",
        pressureJZ3Plus: "69518a3b-c4e0-4def-9c8c-9fb40e860a21",
        pressureJN3Plus: "5c1a46ac-14d8-42b4-832c-a6d00a1915f2",
        pressurePZ4Plus: "52f6550f-e552-4f0b-996c-c41e4d6c1884",
        pressurePN4Plus: "7d2029d4-5d16-433b-9d47-7022b55026f6",
        pressurePZM6Plus: "f29cf450-88a8-4193-98e2-7fd9fdbb0d51",
        pressurePNM6Plus: "7ff59f0c-c8ad-4a94-9df4-37657e00a768",
        pressureJZM5Plus: "bd7909da-d2df-47ce-a34d-3b2ef41218da",
        pressureJNM5Plus: "9595a57e-b9e1-4d63-9927-b8861f2d8f7b",
        pressurePZM4Plus: "e3830dca-9e5a-47e9-b775-8c857057e849",
        pressurePNM4Plus: "45617e75-4740-4447-b032-26311bc4d9d3",
        pressureJZM3Plus: "548a4073-9dd9-4a92-b331-868a7046a331",
        pressureJNM3Plus: "02681585-c8a7-4ba2-8581-f646eb189047",
        pressurePZM2Plus: "2bad39b6-0fc2-4d21-9f25-7c380c9da37e",
        pressurePNM2Plus: "96254e44-4760-4041-b020-438aa0aa02ce",
        pressureJZM1Plus: "7e475eb9-7a7c-4f80-880f-1d3f493fabca",
        pressureJNM1Plus: "c98fe947-1c98-4f98-8ccd-38be63be47b1",
        pressureDehumidifierSteelboxSouthTower: "3dd9e252-3bcf-41fe-bfdd-84bfb073b0ba",

        flowPZ0: "77b586b7-4985-487e-9443-372d833e0dd0",
        flowPN0: "c8a577c1-fd55-4641-86f3-ea3faac832bf",
        flowJZ1: "1b82c3bd-168f-47ad-8974-a49e277ed205",
        flowJN1: "3a7b013f-7973-4353-81cf-0be78974caf3",
        flowPZ2: "a7865089-9154-4c81-b13e-3c8305724fb2",
        flowPN2: "e72dfefe-3aaf-44ed-835e-c0ebe0253ac9",
        flowJZ3: "cdec133d-d54b-45b7-9de9-5eec22e2ff10",
        flowJN3: "13cef5de-5701-4945-84b6-9fcfea9044ab",
        flowPZ4: "4381a16e-2bc7-44f7-a72c-cd1cf8230266",
        flowPN4: "ff5052d5-9153-45f2-aa8b-ef1ff78b2bc3",
        flowPZM6: "607ec650-ba15-44f1-9e27-83f73a13867b",
        flowPNM6: "ba340708-6d7e-43ae-9c0f-3dce69a0a968",
        flowJZM5: "94eb01f9-a69c-47c5-a435-a9bdb778e36e",
        flowJNM5: "a34aa75f-f067-4c96-9fd0-feed223d9740",
        flowPZM4: "cc20a2cf-4c82-44f2-91f0-206d4d4579db",
        flowPNM4: "7803838c-513e-40fc-9b2f-01b7dad96abe",
        flowJZM3: "2d36d4f0-8152-4bc0-8b31-f4c905ae5254",
        flowJNM3: "e18af871-f384-4e3c-8a94-e3518d6c52a4",
        flowPZM2: "51bcac2f-aeff-47c0-bcca-c065f0e79dca",
        flowPNM2: "dbba8230-e05e-4ac7-9a22-033b7ea18818",
        flowJZM1: "88457cf5-45cd-4b15-99d3-d54a246cda0b",
        flowJNM1: "9482b1c7-02d8-42dc-a594-886182b0d8b9",
        flowPZM0: "6d9cf6fe-1079-4fe0-b908-415982626387",
        flowPNM0: "4107511f-cb45-4414-9593-349d7c5a25e0",
        flowPZ0Plus: "53effcea-8810-456e-958c-fbc5432bdd25",
        flowPN0Plus: "7c3c1ff1-9a35-4212-bb55-a146910896b1",
        flowJZ1Plus: "16a7bb0d-011b-4873-9a79-c76b4022a4be",
        flowJN1Plus: "c24240da-d11d-4a9d-8485-4b6b9f1e2eb9",
        flowPZ2Plus: "3575ff5b-2af9-45a1-b49e-3fcec366f954",
        flowPN2Plus: "521cb7c0-0eb5-4237-8505-6f9fd8befa9b",
        flowJZ3Plus: "4b683108-89af-4774-9f32-d8c5f82b9455",
        flowJN3Plus: "89401029-04ec-4c6a-b455-1f7a797d4d30",
        flowPZ4Plus: "0ce23db6-dd5d-40bf-8634-5a2606f94391",
        flowPN4Plus: "1f766be0-c1eb-4df0-8687-3fcf5e803f6a",
        flowPZM6Plus: "3da7750c-14cf-4ec9-bd5f-d3f7157a8787",
        flowPNM6Plus: "b77dd122-9d01-4b29-8396-e04821434e03",
        flowJZM5Plus: "180f3780-86e5-4363-b6b2-296ea501696f",
        flowJNM5Plus: "797a2922-e7ec-423e-8e5d-8aa414efb558",
        flowPZM4Plus: "4a5dbc22-1178-4567-ac29-b741f2026389",
        flowPNM4Plus: "3da47b33-7d60-451d-ac76-17056c222755",
        flowJZM3Plus: "ed8abb12-761e-4e2d-b27f-19cc98bcd3f6",
        flowJNM3Plus: "8ab8f25b-58b4-49da-88d4-ab8ea37fff59",
        flowPZM2Plus: "ab165b3c-5fa0-415e-b5cc-c7d25de59992",
        flowPNM2Plus: "8ff920a2-fdc3-4a5a-a91c-138262f82419",
        flowJZM1Plus: "9263faa1-e68b-4312-8a93-3e6cb54c9791",
        flowJNM1Plus: "acb283f8-cc43-479a-af9b-1ea8f0b99905",

        //running
        runningDehumidifierLeft: "79b4e6f9-6127-4bac-8af7-0e2d4721c5d2",
        runningDehumidifierRight: "e914cf14-f4cc-4fb7-b475-a2d452286f9f",
        runningDehumidifierSteelboxSouthTower: "8c36c4e3-1172-4437-9101-4c1d2ca9175d",

        //malfunction
        malfunctionDehumidifierLeft: "31a3d703-8d99-4712-8a32-dcfe31086179",
        malfunctionDehumidifierRight: "23ae5bfb-b57c-46dd-a23e-c5ffdd955720",
      },

      //humidity allowed max -> id
      allowedMaxNameIdDict: {
        humidityAllowedMaxPZ0: "ca6847b7-c47e-442b-9dfe-4c4a69f6952d",
        humidityAllowedMaxPN0: "0ea8eea2-07e1-4542-a42a-c2ebcc4da119",
        humidityAllowedMaxJZ1: "63d6b596-de71-4aff-b322-d56359f8ae09",
        humidityAllowedMaxJN1: "45551ad9-add9-4e48-bf43-5601cee2ef51",
        humidityAllowedMaxPZ2: "eba2f623-e26d-49e1-85f0-b3a8043ab1fc",
        humidityAllowedMaxPN2: "8b5e0a56-6667-4ce8-884b-3f6e44906134",
        humidityAllowedMaxJZ3: "75510b59-4249-46a0-a35b-232edefd5319",
        humidityAllowedMaxJN3: "63600282-7f67-4dff-b159-85c14847cb36",
        humidityAllowedMaxPZ4: "1fe3605a-e2eb-437a-879d-4d874a727695",
        humidityAllowedMaxPN4: "276b7a3a-3bef-4c6e-8221-d4e3a1d9883c",
        humidityAllowedMaxPZM6: "5707b1e1-7f71-458b-88d1-b5c547e357c7",
        humidityAllowedMaxPNM6: "dd8b03bc-14ec-4d31-8361-3551477d8de0",
        humidityAllowedMaxJZM5: "96408d16-1ac2-4c4b-a856-f9cbe0f34626",
        humidityAllowedMaxJNM5: "a8dd15f6-772e-450f-9c6f-b548e349c4df",
        humidityAllowedMaxPZM4: "3c81cce8-6097-4e21-b8f2-e0bd9fff0d1b",
        humidityAllowedMaxPNM4: "7aeb8470-606b-4e7c-9bcd-9c990aad6144",
        humidityAllowedMaxJZM3: "ecc19039-0f6b-4297-a4c6-89c7103eefef",
        humidityAllowedMaxJNM3: "54cd8a84-edfd-4c51-bfae-fbf7fd23918b",
        humidityAllowedMaxPZM2: "4aa64e64-14fb-4bfb-945d-1d68c63034bc",
        humidityAllowedMaxPNM2: "41be5c81-6ed3-49e4-96e2-076c8df56025",
        humidityAllowedMaxJZM1: "9d271296-6d34-4080-8eb0-b7d85d401f7a",
        humidityAllowedMaxJNM1: "f628e215-2229-454e-a25f-146fcdc41ddb",
        humidityAllowedMaxPZM0: "ce200656-44e0-4015-9a9c-ba289f84d962",
        humidityAllowedMaxPNM0: "60643b5d-7d4f-4b95-888c-9809cadc8c07",
        humidityAllowedMaxPZ0Plus: "a7ac9307-f8f4-4e47-a80b-39d416f567e3",
        humidityAllowedMaxPN0Plus: "b33586f0-cd88-4684-96c2-a820e0373a58",
        humidityAllowedMaxJZ1Plus: "91bc95ff-6f2c-415e-ac97-af9bec16a746",
        humidityAllowedMaxJN1Plus: "a0f66c55-3167-4117-84da-d8f2096d4441",
        humidityAllowedMaxPZ2Plus: "70a76f2c-b4bc-43d1-99e0-23c32ff7a035",
        humidityAllowedMaxPN2Plus: "5cfc36db-0588-4a8b-9a4f-501bb6649f34",
        humidityAllowedMaxJZ3Plus: "4d5767ea-d8b0-4098-a8b9-b12933477bd1",
        humidityAllowedMaxJN3Plus: "cdb3ca60-261c-4921-95f3-a0ed5a7f7ee0",
        humidityAllowedMaxPZ4Plus: "3034b70b-f3e4-40bb-9812-b1f05e1d4634",
        humidityAllowedMaxPN4Plus: "aca09fc4-5f70-4a6e-8705-f1790ce95a27",
        humidityAllowedMaxPZM6Plus: "a442056b-15df-4a2c-8383-0ae148558dfc",
        humidityAllowedMaxPNM6Plus: "833f777d-088c-4d13-9414-ea6a18a4f1a7",
        humidityAllowedMaxJZM5Plus: "6202abe7-e0f6-4d32-ab56-eb5caa1357f4",
        humidityAllowedMaxJNM5Plus: "8ae69e75-8d92-446c-bdb2-6ef4cf56d1b5",
        humidityAllowedMaxPZM4Plus: "aa2338a1-49a2-41c7-973e-ad10b21a1b88",
        humidityAllowedMaxPNM4Plus: "a47905bd-da46-4eeb-94ec-e77890ac6de2",
        humidityAllowedMaxJZM3Plus: "7c9f6740-86b4-44e4-9b4f-932616d53b41",
        humidityAllowedMaxJNM3Plus: "f1737f11-63ed-423e-8e9b-b8c00a9ec398",
        humidityAllowedMaxPZM2Plus: "278ab36f-c460-446e-8f37-e09b62a967d9",
        humidityAllowedMaxPNM2Plus: "4d74ebe0-ad25-45b5-ae39-6301830a9665",
        humidityAllowedMaxJZM1Plus: "71c4f92c-301a-4dc9-9bcd-97cd6429eb2d",
        humidityAllowedMaxJNM1Plus: "66d77cff-a70f-45bc-aa46-4e5d005b1a92",
        humidityAllowedMaxDehumidifierLeft: "ea50a278-9f53-4aaf-bf2c-bb7c576a8308",
        humidityAllowedMaxDehumidifierRight: "a7f05749-e227-4021-b390-928934fe5fea",
        humidityAllowedMaxDehumidifierEquivalentLeft: "c0d81c98-c485-4795-8f3f-87a2b3acd516",
        humidityAllowedMaxDehumidifierEquivalentRight: "03e55848-49d7-4551-9d05-f6dd9bd2a0cd",
        humidityAllowedMaxDehumidifierSteelboxSouthTower: "38efbd32-db59-44f7-9070-933116d1cc49",
      },

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        humidityPZ0: "errorPZ0",
        humidityPN0: "errorPN0",
        humidityJZ1: "errorJZ1",
        humidityJN1: "errorJN1",
        humidityPZ2: "errorPZ2",
        humidityPN2: "errorPN2",
        humidityJZ3: "errorJZ3",
        humidityJN3: "errorJN3",
        humidityPZ4: "errorPZ4",
        humidityPN4: "errorPN4",
        humidityPZM6: "errorPZM6",
        humidityPNM6: "errorPNM6",
        humidityJZM5: "errorJZM5",
        humidityJNM5: "errorJNM5",
        humidityPZM4: "errorPZM4",
        humidityPNM4: "errorPNM4",
        humidityJZM3: "errorJZM3",
        humidityJNM3: "errorJNM3",
        humidityPZM2: "errorPZM2",
        humidityPNM2: "errorPNM2",
        humidityJZM1: "errorJZM1",
        humidityJNM1: "errorJNM1",
        humidityPZM0: "errorPZM0",
        humidityPNM0: "errorPNM0",
        humidityPZ0Plus: "errorPZ0Plus",
        humidityPN0Plus: "errorPN0Plus",
        humidityJZ1Plus: "errorJZ1Plus",
        humidityJN1Plus: "errorJN1Plus",
        humidityPZ2Plus: "errorPZ2Plus",
        humidityPN2Plus: "errorPN2Plus",
        humidityJZ3Plus: "errorJZ3Plus",
        humidityJN3Plus: "errorJN3Plus",
        humidityPZ4Plus: "errorPZ4Plus",
        humidityPN4Plus: "errorPN4Plus",
        humidityPZM6Plus: "errorPZM6Plus",
        humidityPNM6Plus: "errorPNM6Plus",
        humidityJZM5Plus: "errorJZM5Plus",
        humidityJNM5Plus: "errorJNM5Plus",
        humidityPZM4Plus: "errorPZM4Plus",
        humidityPNM4Plus: "errorPNM4Plus",
        humidityJZM3Plus: "errorJZM3Plus",
        humidityJNM3Plus: "errorJNM3Plus",
        humidityPZM2Plus: "errorPZM2Plus",
        humidityPNM2Plus: "errorPNM2Plus",
        humidityJZM1Plus: "errorJZM1Plus",
        humidityJNM1Plus: "errorJNM1Plus",

        temperaturerPZ0: "errorPZ0",
        temperaturerPN0: "errorPN0",
        temperaturerJZ1: "errorJZ1",
        temperaturerJN1: "errorJN1",
        temperaturerPZ2: "errorPZ2",
        temperaturerPN2: "errorPN2",
        temperaturerJZ3: "errorJZ3",
        temperaturerJN3: "errorJN3",
        temperaturerPZ4: "errorPZ4",
        temperaturerPN4: "errorPN4",
        temperaturerPZM6: "errorPZM6",
        temperaturerPNM6: "errorPNM6",
        temperaturerJZM5: "errorJZM5",
        temperaturerJNM5: "errorJNM5",
        temperaturerPZM4: "errorPZM4",
        temperaturerPNM4: "errorPNM4",
        temperaturerJZM3: "errorJZM3",
        temperaturerJNM3: "errorJNM3",
        temperaturerPZM2: "errorPZM2",
        temperaturerPNM2: "errorPNM2",
        temperaturerJZM1: "errorJZM1",
        temperaturerJNM1: "errorJNM1",
        temperaturerPZM0: "errorPZM0",
        temperaturerPNM0: "errorPNM0",
        temperaturerPZ0Plus: "errorPZ0Plus",
        temperaturerPN0Plus: "errorPN0Plus",
        temperaturerJZ1Plus: "errorJZ1Plus",
        temperaturerJN1Plus: "errorJN1Plus",
        temperaturerPZ2Plus: "errorPZ2Plus",
        temperaturerPN2Plus: "errorPN2Plus",
        temperaturerJZ3Plus: "errorJZ3Plus",
        temperaturerJN3Plus: "errorJN3Plus",
        temperaturerPZ4Plus: "errorPZ4Plus",
        temperaturerPN4Plus: "errorPN4Plus",
        temperaturerPZM6Plus: "errorPZM6Plus",
        temperaturerPNM6Plus: "errorPNM6Plus",
        temperaturerJZM5Plus: "errorJZM5Plus",
        temperaturerJNM5Plus: "errorJNM5Plus",
        temperaturerPZM4Plus: "errorPZM4Plus",
        temperaturerPNM4Plus: "errorPNM4Plus",
        temperaturerJZM3Plus: "errorJZM3Plus",
        temperaturerJNM3Plus: "errorJNM3Plus",
        temperaturerPZM2Plus: "errorPZM2Plus",
        temperaturerPNM2Plus: "errorPNM2Plus",
        temperaturerJZM1Plus: "errorJZM1Plus",
        temperaturerJNM1Plus: "errorJNM1Plus",

        pressurePZ0: "errorPZ0",
        pressurePN0: "errorPN0",
        pressureJZ1: "errorJZ1",
        pressureJN1: "errorJN1",
        pressurePZ2: "errorPZ2",
        pressurePN2: "errorPN2",
        pressureJZ3: "errorJZ3",
        pressureJN3: "errorJN3",
        pressurePZ4: "errorPZ4",
        pressurePN4: "errorPN4",
        pressurePZM6: "errorPZM6",
        pressurePNM6: "errorPNM6",
        pressureJZM5: "errorJZM5",
        pressureJNM5: "errorJNM5",
        pressurePZM4: "errorPZM4",
        pressurePNM4: "errorPNM4",
        pressureJZM3: "errorJZM3",
        pressureJNM3: "errorJNM3",
        pressurePZM2: "errorPZM2",
        pressurePNM2: "errorPNM2",
        pressureJZM1: "errorJZM1",
        pressureJNM1: "errorJNM1",
        pressurePZM0: "errorPZM0",
        pressurePNM0: "errorPNM0",
        pressurePZ0Plus: "errorPZ0Plus",
        pressurePN0Plus: "errorPN0Plus",
        pressureJZ1Plus: "errorJZ1Plus",
        pressureJN1Plus: "errorJN1Plus",
        pressurePZ2Plus: "errorPZ2Plus",
        pressurePN2Plus: "errorPN2Plus",
        pressureJZ3Plus: "errorJZ3Plus",
        pressureJN3Plus: "errorJN3Plus",
        pressurePZ4Plus: "errorPZ4Plus",
        pressurePN4Plus: "errorPN4Plus",
        pressurePZM6Plus: "errorPZM6Plus",
        pressurePNM6Plus: "errorPNM6Plus",
        pressureJZM5Plus: "errorJZM5Plus",
        pressureJNM5Plus: "errorJNM5Plus",
        pressurePZM4Plus: "errorPZM4Plus",
        pressurePNM4Plus: "errorPNM4Plus",
        pressureJZM3Plus: "errorJZM3Plus",
        pressureJNM3Plus: "errorJNM3Plus",
        pressurePZM2Plus: "errorPZM2Plus",
        pressurePNM2Plus: "errorPNM2Plus",
        pressureJZM1Plus: "errorJZM1Plus",
        pressureJNM1Plus: "errorJNM1Plus",

        flowPZ0: "errorPZ0",
        flowPN0: "errorPN0",
        flowJZ1: "errorJZ1",
        flowJN1: "errorJN1",
        flowPZ2: "errorPZ2",
        flowPN2: "errorPN2",
        flowJZ3: "errorJZ3",
        flowJN3: "errorJN3",
        flowPZ4: "errorPZ4",
        flowPN4: "errorPN4",
        flowPZM6: "errorPZM6",
        flowPNM6: "errorPNM6",
        flowJZM5: "errorJZM5",
        flowJNM5: "errorJNM5",
        flowPZM4: "errorPZM4",
        flowPNM4: "errorPNM4",
        flowJZM3: "errorJZM3",
        flowJNM3: "errorJNM3",
        flowPZM2: "errorPZM2",
        flowPNM2: "errorPNM2",
        flowJZM1: "errorJZM1",
        flowJNM1: "errorJNM1",
        flowPZM0: "errorPZM0",
        flowPNM0: "errorPNM0",
        flowPZ0Plus: "errorPZ0Plus",
        flowPN0Plus: "errorPN0Plus",
        flowJZ1Plus: "errorJZ1Plus",
        flowJN1Plus: "errorJN1Plus",
        flowPZ2Plus: "errorPZ2Plus",
        flowPN2Plus: "errorPN2Plus",
        flowJZ3Plus: "errorJZ3Plus",
        flowJN3Plus: "errorJN3Plus",
        flowPZ4Plus: "errorPZ4Plus",
        flowPN4Plus: "errorPN4Plus",
        flowPZM6Plus: "errorPZM6Plus",
        flowPNM6Plus: "errorPNM6Plus",
        flowJZM5Plus: "errorJZM5Plus",
        flowJNM5Plus: "errorJNM5Plus",
        flowPZM4Plus: "errorPZM4Plus",
        flowPNM4Plus: "errorPNM4Plus",
        flowJZM3Plus: "errorJZM3Plus",
        flowJNM3Plus: "errorJNM3Plus",
        flowPZM2Plus: "errorPZM2Plus",
        flowPNM2Plus: "errorPNM2Plus",
        flowJZM1Plus: "errorJZM1Plus",
        flowJNM1Plus: "errorJNM1Plus",

        humidityDehumidifierLeft: "errorDehumidifierLeft",
        temperatureDehumidifierLeft: "errorDehumidifierLeft",
        humidityDehumidifierRight: "errorDehumidifierRight",
        temperatureDehumidifierRight: "errorDehumidifierRight",
        humidityDehumidifierEquivalentLeft: "errorDehumidifierLeft",
        humidityDehumidifierEquivalentRight: "errorDehumidifierRight",

        humidityDehumidifierSteelboxSouthTower: "errorDehumidifierSteelboxSouthTower",
        temperatureDehumidifierSteelboxSouthTower: "errorDehumidifierSteelboxSouthTower",
        pressureDehumidifierSteelboxSouthTower: "errorDehumidifierSteelboxSouthTower",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict: {
        malfunctionDehumidifierLeft: "errorDehumidifierLeft",
        malfunctionDehumidifierRight: "errorDehumidifierRight",
      },

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {
        humidityPZ0: "humidityTooltipErrorPZ0",
        humidityPN0: "humidityTooltipErrorPN0",
        humidityJZ1: "humidityTooltipErrorJZ1",
        humidityJN1: "humidityTooltipErrorJN1",
        humidityPZ2: "humidityTooltipErrorPZ2",
        humidityPN2: "humidityTooltipErrorPN2",
        humidityJZ3: "humidityTooltipErrorJZ3",
        humidityJN3: "humidityTooltipErrorJN3",
        humidityPZ4: "humidityTooltipErrorPZ4",
        humidityPN4: "humidityTooltipErrorPN4",
        humidityPZM6: "humidityTooltipErrorPZM6",
        humidityPNM6: "humidityTooltipErrorPNM6",
        humidityJZM5: "humidityTooltipErrorJZM5",
        humidityJNM5: "humidityTooltipErrorJNM5",
        humidityPZM4: "humidityTooltipErrorPZM4",
        humidityPNM4: "humidityTooltipErrorPNM4",
        humidityJZM3: "humidityTooltipErrorJZM3",
        humidityJNM3: "humidityTooltipErrorJNM3",
        humidityPZM2: "humidityTooltipErrorPZM2",
        humidityPNM2: "humidityTooltipErrorPNM2",
        humidityJZM1: "humidityTooltipErrorJZM1",
        humidityJNM1: "humidityTooltipErrorJNM1",
        humidityPZM0: "humidityTooltipErrorPZM0",
        humidityPNM0: "humidityTooltipErrorPNM0",
        humidityPZ0Plus: "humidityTooltipErrorPZ0Plus",
        humidityPN0Plus: "humidityTooltipErrorPN0Plus",
        humidityJZ1Plus: "humidityTooltipErrorJZ1Plus",
        humidityJN1Plus: "humidityTooltipErrorJN1Plus",
        humidityPZ2Plus: "humidityTooltipErrorPZ2Plus",
        humidityPN2Plus: "humidityTooltipErrorPN2Plus",
        humidityJZ3Plus: "humidityTooltipErrorJZ3Plus",
        humidityJN3Plus: "humidityTooltipErrorJN3Plus",
        humidityPZ4Plus: "humidityTooltipErrorPZ4Plus",
        humidityPN4Plus: "humidityTooltipErrorPN4Plus",
        humidityPZM6Plus: "humidityTooltipErrorPZM6Plus",
        humidityPNM6Plus: "humidityTooltipErrorPNM6Plus",
        humidityJZM5Plus: "humidityTooltipErrorJZM5Plus",
        humidityJNM5Plus: "humidityTooltipErrorJNM5Plus",
        humidityPZM4Plus: "humidityTooltipErrorPZM4Plus",
        humidityPNM4Plus: "humidityTooltipErrorPNM4Plus",
        humidityJZM3Plus: "humidityTooltipErrorJZM3Plus",
        humidityJNM3Plus: "humidityTooltipErrorJNM3Plus",
        humidityPZM2Plus: "humidityTooltipErrorPZM2Plus",
        humidityPNM2Plus: "humidityTooltipErrorPNM2Plus",
        humidityJZM1Plus: "humidityTooltipErrorJZM1Plus",
        humidityJNM1Plus: "humidityTooltipErrorJNM1Plus",
        humidityDehumidifierLeft: "humidityTooltipErrorDehumidifierLeft",
        humidityDehumidifierRight: "humidityTooltipErrorDehumidifierRight",
        humidityDehumidifierEquivalentLeft: "humidityTooltipErrorDehumidifierEquivalentLeft",
        humidityDehumidifierEquivalentRight: "humidityTooltipErrorDehumidifierEquivalentRight",
        humidityDehumidifierSteelboxSouthTower: "humidityTooltipErrorDehumidifierSteelboxSouthTower",
      },

      //running -> running class
      dataNameRunningClassNameDict: {
        runningDehumidifierLeft: "runningClassLeft",
        runningDehumidifierRight: "runningClassRight",
        runningDehumidifierSteelboxSouthTower: "runningClassSteelboxSouthTower",
      },

      //station id list
      stationIdList: [
        "86eafaa0-49be-4580-9f6a-92c293e3936d",
        "431deef2-b5f1-4e70-83ca-5a75e259d6a0",
        "4ade1b4b-0eda-459a-88db-95cdf09387ff",
        "9658719c-40d9-4c73-bc71-f0fe706733f9",
      ],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );
    },
    setDataAndError(stationData) {
      //device id not set (device id = 'GUID') = no data
      stationData["GUID"] = {
        dataId: null,
        deviceId: "GUID",
        value: null,
        createdDate: "0001-01-01T00:00:00",
        dataDate: "0001-01-01T00:00:00",
        dataType: "VALUE",
        errorLevel: "Warning",
      };

      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if (
        (errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") &&
        allowedMax !== undefined &&
        allowedMax !== null &&
        !isNaN(parseInt(allowedMax))
      ) {
        if (allowedMax === 0) {
          result += "(无限制)";
        } else {
          result += "(<" + allowedMax + "%RH)";
        }
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag, dehumidifierName) {
      let result = "";
      if (name) {
        result += name + ": ";
      }
      if(!dehumidifierName || dehumidifierName === ""){
        dehumidifierName = "除湿机";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (errorLevel.toLowerCase() !== "warning") {
        if (runningFlag > 0) {
          result += ", "+dehumidifierName+"运行";
        } else if (runningFlag === 0) {
          result += ", "+dehumidifierName+"停止";
        }
      }

      if (errorFlag > 0) {
        result += ", 故障报警";
      }

      return result;
    },
    hrefToScenario(id){
      if(!id || id===''){
        return;
      }

      this.$router.push("/"+this.routerPrefix+"/dataHistory?bridgeId="+this.bridgeId+"&scenarioId="+id);
    },
    hrefToStation(id){
      if(!id || id === ''){
        return;
      }

      this.$router.push("/"+this.routerPrefix+id);
    },
  },
};
</script>
      
      <style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }
  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
 // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 35px;
        font-weight: bold;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1200px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .sensor1:after {
          background: #c7798b;
        }
        .sensor2:after {
          background: #3376c7;
        }
      }
      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .default:after {
          background: #ffff00;
        }
        .running:after {
          background: #67dd34;
        }
        .stopped:after {
          background: #a0a0a0;
        }
      }
      .legend-station {
        position: absolute;
        left: 73px;
        top: 108px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }
        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 250px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 250px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 300px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/xihoumen/bridgeLine.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .station-block-left {
          top: 122px;
          left: 173px;
        }

        .station-block-middle {
          top: 122px;
          left: 582px;
        }

        .station-block-right {
          top: 122px;
          left: 990px;
        }

        .stati {
          position: absolute;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);
            &:before {
              background-color: #ed6a5a;
            }
            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos:before {
              left: 50%;
              top: 94%;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }
              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            & > p {
              margin: 0;
              white-space: nowrap;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos:before {
              left: 50%;
              top: 90%;
              transform: translate(0%, 0%);
            }
            &.top-pos:before {
              left: 50%;
              top: -3px;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
          &.sensor1 {
            background: #c7798b;
            &:after,
            &:before {
              background: #c7798b;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.sensor2 {
            background: #3376c7;
            &:after,
            &:before {
              background: #3376c7;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #3376c7;
              }
            }
          }
        }

        .sensor-right-1 {
          top: 184px;
          left: 1132px;
          &::before {
            bottom: 22px;
            left: -3px;
            width: 40px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 39px;
            left: 27px;
          }
          .state-info {
            right: -165px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-right-3 {
          top: 153px;
          left: 1050px;
          &::before {
            bottom: -40px;
            left: -34px;
            width: 100px;
            transform: rotate(260deg);
          }
          &::after {
            bottom: -89px;
            left: 24px;
          }
          .state-info {
            right: -165px;
            top: 103px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-right-5 {
          top: 117px;
          left: 962px;
          &::before {
            bottom: 35px;
            left: -17px;
            width: 60px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 64px;
            left: 18px;
          }
          .state-info {
            right: -162px;
            top: -49px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-13 {
          top: 117px;
          left: 937px;
          &::before {
            bottom: 45px;
            left: -45px;
            width: 90px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 89px;
            left: -23px;
          }
          .state-info {
            right: 40px;
            top: -74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-11 {
          top: 150px;
          left: 835px;
          &::before {
            bottom: 22px;
            left: -21px;
            width: 40px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 39px;
            left: -26px;
          }
          .state-info {
            right: 40px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-9 {
          top: 170px;
          left: 732px;
          &::before {
            bottom: -25px;
            left: -22px;
            width: 70px;
            transform: rotate(260deg);
          }
          &::after {
            bottom: -59px;
            left: 18px;
          }
          .state-info {
            right: -162px;
            top: 74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-7 {
          top: 180px;
          left: 625px;
          &::before {
            bottom: -5px;
            left: -4px;
            width: 25px;
            transform: rotate(90deg);
          }
          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }
          .state-info {
            right: -61px;
            top: 59px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-5 {
          top: 170px;
          left: 518px;
          &::before {
            bottom: -25px;
            left: -32px;
            width: 70px;
            transform: rotate(280deg);
          }
          &::after {
            bottom: -59px;
            left: -18px;
          }
          .state-info {
            right: 33px;
            top: 74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-3 {
          top: 150px;
          left: 405px;
          &::before {
            bottom: 22px;
            left: -2px;
            width: 40px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 39px;
            left: 27px;
          }
          .state-info {
            right: -170px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-1 {
          top: 117px;
          left: 300px;
          &::before {
            bottom: 45px;
            left: -30px;
            width: 90px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 89px;
            left: 23px;
          }
          .state-info {
            right: -165px;
            top: -74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-left-5 {
          top: 117px;
          left: 275px;
          &::before {
            bottom: 35px;
            left: -28px;
            width: 60px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 64px;
            left: -18px;
          }
          .state-info {
            right: 35px;
            top: -49px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-left-3 {
          top: 157px;
          left: 175px;
          &::before {
            bottom: -40px;
            left: -51px;
            width: 100px;
            transform: rotate(280deg);
          }
          &::after {
            bottom: -89px;
            left: -24px;
          }
          .state-info {
            right: 40px;
            top: 103px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-left-1 {
          top: 182px;
          left: 72px;
          &::before {
            bottom: 22px;
            left: -23px;
            width: 40px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 39px;
            left: -27px;
          }
          .state-info {
            right: 40px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-right-2 {
          top: 168px;
          left: 1093px;
          &::before {
            bottom: 22px;
            left: -3px;
            width: 40px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 39px;
            left: 27px;
          }
          .state-info {
            right: -165px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-right-4 {
          top: 132px;
          left: 998px;
          &::before {
            bottom: 38px;
            left: -21px;
            width: 70px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 73px;
            left: 20px;
          }
          .state-info {
            right: -165px;
            top: -58px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-12 {
          top: 135px;
          left: 885px;
          &::before {
            bottom: 45px;
            left: -45px;
            width: 90px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 89px;
            left: -23px;
          }
          .state-info {
            right: 40px;
            top: -74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-10 {
          top: 158px;
          left: 805px;
          &::before {
            bottom: 22px;
            left: -21px;
            width: 40px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 39px;
            left: -26px;
          }
          .state-info {
            right: 40px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-8 {
          top: 177px;
          left: 675px;
          &::before {
            bottom: -25px;
            left: -22px;
            width: 70px;
            transform: rotate(260deg);
          }
          &::after {
            bottom: -59px;
            left: 18px;
          }
          .state-info {
            right: -162px;
            top: 74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-6 {
          top: 177px;
          left: 570px;
          &::before {
            bottom: -25px;
            left: -32px;
            width: 70px;
            transform: rotate(280deg);
          }
          &::after {
            bottom: -59px;
            left: -18px;
          }
          .state-info {
            right: 33px;
            top: 74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-4 {
          top: 158px;
          left: 440px;
          &::before {
            bottom: 22px;
            left: -2px;
            width: 40px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 39px;
            left: 27px;
          }
          .state-info {
            right: -170px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-2 {
          top: 135px;
          left: 350px;
          &::before {
            bottom: 45px;
            left: -30px;
            width: 90px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 89px;
            left: 23px;
          }
          .state-info {
            right: -165px;
            top: -74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-left-4 {
          top: 132px;
          left: 240px;
          &::before {
            bottom: 38px;
            left: -33px;
            width: 70px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 73px;
            left: -19px;
          }
          .state-info {
            right: 34px;
            top: -58px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-left-2 {
          top: 168px;
          left: 145px;
          &::before {
            bottom: 22px;
            left: -20px;
            width: 40px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 39px;
            left: -25px;
          }
          .state-info {
            right: 35px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .station-block-left {
          top: 108px;
          left: 282px;
        }

        .sta-left {
          top: 108px;
          left: 282px;
          &::before {
            bottom: 15px;
            left: -18px;
            width: 60px;
            transform: rotate(90deg);
          }
          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }
          .state-info {
            right: -73px;
            top: -76px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .station-block-right {
          top: 108px;
          left: 945px;
        }

        .sta-right {
          top: 108px;
          left: 945px;
          &::before {
            bottom: 15px;
            left: -18px;
            width: 60px;
            transform: rotate(90deg);
          }
          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }
          .state-info {
            right: -70px;
            top: -76px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 115px;
          }
        }

        .station-block-steelbox-south-tower {
          top: 180px;
          left: 945px;
        }

        .sta-steelbox-south-tower {
          top: 180px;
          left: 945px;
          &::before {
            bottom: -45px;
            left: -10px;
            width: 55px;
            transform: rotate(260deg);
          }
          &::after {
            bottom: -72px;
            left: 23px;
          }
          .state-info {
            right: -185px;
            top: 71px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }
      }
    }
  }
}
</style>